export default "__VITE_ASSET__DlK$mrcd__"